import { GROUPS_PATH } from "components/Groups/constants/groupsConsts";
import { getIntroTutorialSteps } from "../steps/introTutorialSteps";
import { TUTORIAL_PAGES, TUTORIALS } from "./tutorialConsts";
import { getEditLayoutTutorialSteps } from "../steps/editLayoutSteps";
import { getResizableSectionTutorialSteps } from "../steps/resizableSteps";
import { IntroTutorial } from "../steps/IntroTutorial";

export const TUTORIALS_CONFIG = {
  [TUTORIALS.INTRO]: {
    label: "Intro",
    component: IntroTutorial,
    getSteps: getIntroTutorialSteps,
    requiredStartPath: `/${GROUPS_PATH}`,
  },
  [TUTORIALS.EDIT_LAYOUT]: {
    label: "Edit Layout",
    page: TUTORIAL_PAGES.CHARACTER,
    prerequisites: {
      tutorials: [TUTORIALS.INTRO],
    },
    shouldHideOnSkipToEnd: true,
    getSteps: getEditLayoutTutorialSteps,
  },
  [TUTORIALS.RESIZABLE]: {
    label: "Resizable Section",
    page: TUTORIAL_PAGES.CHARACTER,
    prerequisites: {
      tutorials: [TUTORIALS.INTRO],
    },
    getSteps: getResizableSectionTutorialSteps,
  },
};
